<template>
  <div class="list-page">
    <crumbs title="成果对接管理" />
    <div class="list-page__querybar">
      <el-row>
        <el-col :span="6">
          <enumerate
            url="/api/Project/GetProDockingState"
            v-model="queryCondition.projectStatus"
            placeholder="项目状态"
          />
        </el-col>
        <el-col :span="6">
          <enumerate
            url="/api/Project/GetDockingStatus"
            v-model="queryCondition.dockingStatus"
            placeholder="项目流程状态"
          />
        </el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="queryCondition.createDate"
            type="daterange"
            :unlink-panels="true"
            start-placeholder="对接时间"
            end-placeholder="对接时间"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6">
          <el-date-picker
            v-model="queryCondition.updateDate"
            type="daterange"
            :unlink-panels="true"
            start-placeholder="更新时间"
            end-placeholder="更新时间"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          >
          </el-date-picker>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-input
            v-model="queryCondition.userName"
            clearable
            placeholder="账号昵称"
          >
          </el-input>
        </el-col>
        <el-col :span="16">
          <el-input
            v-model="queryCondition.keyWords"
            clearable
            placeholder="搜索成果名称"
          >
          </el-input>
        </el-col>
        <el-col class="fn-text-right" :span="2">
          <el-button
            @click="handleSearch"
            size="medium"
            type="success"
            icon="el-icon-search"
            round
            >查询</el-button
          >
        </el-col>
      </el-row>
    </div>
    <div class="list-page__toolbar" v-if="false">
      <el-button
        type="warning"
        icon="el-icon-circle-plus"
        @click="redirectByPath(`/admin/dockingManage/achDockingInfo/addition`)"
        >添加
      </el-button>
      <el-button type="warning" icon="el-icon-delete" @click="handleBatchDelete"
        >删除</el-button
      >
    </div>
    <div
      class="list-page__table"
      v-loading="isLoading"
      element-loading-text="拼命加载中"
    >
      <el-table
        :data="queryList"
        @selection-change="handleSelectionChange"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <!-- <el-table-column type="selection" width="40"> </el-table-column> -->
        <el-table-column prop="code" label="对接编号" align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="成果名称"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="projectStatusName"
          label="项目状态"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          prop="dockingStatusName"
          label="项目流程状态"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column label="对接时间" width="90" align="center">
          <template slot-scope="scope">
            <p>
              {{ scope.row.createTime.trim().split(/\s+/)[0] }}
            </p>
            <!-- <p>
                {{ scope.row.createTime.trim().split(/\s+/)[1] }}
              </p> -->
          </template>
        </el-table-column>
        <el-table-column label="更新时间" width="90" align="center">
          <template slot-scope="scope">
            <p>
              {{ scope.row.lastUpdateTime.trim().split(/\s+/)[0] }}
            </p>
            <!-- <p>
                {{ scope.row.lastUpdateTime.trim().split(/\s+/)[1] }}
              </p> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" width="220" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="warning" @click="handleLook(scope.row)"
              >查看</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="fn-text-center mt-20">
        <el-pagination
          background
          layout="total, prev, pager, next, jumper"
          :hide-on-single-page="true"
          :total="total"
          :page-size="queryCondition.pageSize"
          :current-page.sync="queryCondition.pageIndex"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "achDockingList",
  data() {
    return {
      //查询条件
      queryCondition: {
        projectStatus: "",
        dockingStatus: "",
        createDate: [],
        updateDate: [],
        userName: "",
        keyWords: "",
        pageIndex: 1,
        pageSize: 15
      },
      total: 0,
      //是否处于loading状态
      isLoading: true,
      //查询结果
      queryList: [],
      //表格当前的选项（多选）
      multipleSelection: []
    };
  },
  created() {
    this.createQueryCondition();
    this.loadList();
  },
  methods: {
    //出来参数
    processParams() {
      let { keyWords, userName, pageIndex, pageSize, createDate, updateDate } =
          this.queryCondition,
        mixin = {
          projectStatus: "",
          dockingStatus: ""
        },
        [createDateStart = "", createDateEnd = ""] = createDate || [],
        [updateDateStart = "", updateDateEnd = ""] = updateDate || [];
      Object.keys(mixin).map((item) => {
        mixin[item] =
          this.queryCondition[item] === "" ? -1 : this.queryCondition[item];
      });
      return {
        keyWords,
        userName,
        pageIndex,
        pageSize,
        ...mixin,
        createDateStart,
        createDateEnd,
        updateDateStart,
        updateDateEnd
      };
    },
    //获取列表
    loadList() {
      //初始化
      // this.queryList = [];
      this.isLoading = true;
      this.$api("project", "getAchProjectList", this.processParams()).then(
        (res) => {
          this.isLoading = false;
          this.total = res.count;
          this.queryList = res.dataList;
        }
      );
    },
    //点击后查询
    handleSearch() {
      this.queryCondition.pageIndex = 1;
      this.loadList();
    },
    //表格相关
    //点击选中/取消选中表格选择项
    handleSelectionChange(selection) {
      this.multipleSelection = selection;
    },
    //点击编辑
    handleLook(row) {
      const { id } = row;
      this.redirectByPath(
        `/admin/dockingManage/achDockingInfo`,
        {
          id
        },
        this.queryCondition
      );
    },
    //删除
    //点击批量删除
    handleBatchDelete() {
      const idList = this.multipleSelection.map((item) => item.id);
      if (idList.length) {
        this.$confirm("此操作将批量删除所选中的数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.loadDeleteData(idList);
          })
          .catch(() => {});
      }
    },
    //点击一条删除
    handleDelete(row) {
      this.$confirm("此操作将删除当前所选中的数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.loadDeleteData(row.id);
        })
        .catch(() => {});
    },
    loadDeleteData(id) {
      this.$api("project", "deleteProject", { id }).then((res) => {
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.loadList();
        }
      });
    },
    //点击切换分页触发
    handleCurrentChange() {
      this.loadList();
    }
  }
};
</script>

<style></style>
